<template>
  <div id='grid-wrapper'
       :class='{active: this.gridActive}'
       class='padding-top'>
    <div v-if='tag'
         class='padding-bottom'>Tag:
      <strong>
        <span v-if='language === "en" && tag.description'
              v-html='tag.description'></span>
        <span v-else
              v-html='tag.name'></span>
      </strong>
    </div>
    <div v-if='location.zoek && language === "nl"'
         class='padding-bottom'>Zoekresultaten voor
      <strong>{{ $route.params.slug }}</strong>
    </div>
    <div v-if='location.zoek && language === "en"'
         class='padding-bottom'>Search results for
      <strong>{{ $route.params.slug }}</strong>
    </div>
    <div v-show='filtered && $route.name === "programma"'
         id='filter-description'
         class='filter-description border-bottom margin-bottom'>
      <div v-for='item in filters'>
        <div v-if='item.description.length > 0'
             class='category-description'
             :class='"category-" + item.id'>
          <div v-if='language === "nl" || item.acf.english_name.length < 1'
               class='title'>
            <strong>{{item.name}}</strong>
          </div>
          <div v-else
               class='title'>
            <strong>{{item.acf.english_name}}</strong>
          </div>
          <div v-if='language === "nl" || item.acf.english_description.length < 1'
               class='description'>{{item.description}}</div>
          <div v-else
               class='description'>{{item.acf.english_description}}</div>
        </div>
      </div>
    </div>
    <div id="grid">
      <dsGridItem v-for='item in posts'
                  :item="item"
                  :language="language"
                  :tags='tags'
                  :location='location'
                  :screen-size='screenSize'></dsGridItem>
    </div>
  </div>
</template>

<script>
import dsGridItem from './dsGridItem'
import Isotope from 'isotope-layout'
import globalgrid from '../globalGrid'
export default {
  name: 'dsGrid',
  components: {
    dsGridItem
  },
  props: [
    'language',
    'posts',
    'tags',
    'tag',
    'search',
    'location',
    'screenSize',
    'filter',
    'filters'
  ],
  data() {
    return {
      gridActive: false,
      filtered: false
    }
  },
  mounted() {
    this.initGrid()
    this.gridActive = true
    this.setArrangeHandler()
  },
  destroyed() {
    globalgrid.grid.destroy()
  },
  methods: {
    initGrid() {
      const el = document.querySelector('#grid')
      globalgrid.grid = new Isotope(el, {
        itemSelector: '.grid-item',
        transitionDuration: 0,
        masonry: {
          columnWidth: 316,
          gutter: 30,
          transitionDuration: 0
        }
      })
    },
    setArrangeHandler() {
      setTimeout(() => {
        console.log('--- SETTING UP ARRANGE HANDLER')
        console.dir(globalgrid.grid)
        globalgrid.grid.on('arrangeComplete', e => {
          if (globalgrid.grid.options.filter.length > 0 && globalgrid.grid.options.filter !== '*') {
            console.log('rearranged')
            let filterDescription = document.getElementById('filter-description')
            // Convert nodeList to Array
            let allDescriptions = [].slice.call(
              filterDescription.querySelectorAll('.category-description')
            )
            allDescriptions.map(e => e.classList.remove('shown'))
            console.log('filter 666666')
            console.dir(globalgrid.grid.options.filter)
            let activeDescription = filterDescription.querySelector(globalgrid.grid.options.filter)
            console.log('desc')
            console.dir(activeDescription)
            if (activeDescription) {
              this.filtered = true
              activeDescription.classList.add('shown')
            } else {
              this.filtered = false
            }
          } else {
            this.filtered = false
          }
        })
      }, 500)
    }
  },
  watch: {
    $route: {
      handler: function() {
        this.gridActive = false
        globalgrid.grid.destroy()
        setTimeout(() => {
          this.gridActive = true
          this.initGrid()
          this.setArrangeHandler()
        }, 500)
      }
    }
  }
}
</script>

<style lang='scss'>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

#grid-wrapper {
  opacity: 0;
  &.active {
    opacity: 1;
  }
}

.grid {
  padding-top: $baseline;
  width: 100%;
}

.filter-description {
  width: 100%;
  min-height: 100px;
}

.title {
  font-weight: bold;
}

.category-description {
  display: none;
}
.shown {
  display: block;
}
</style>



// WEBPACK FOOTER //
// dsGrid.vue?74d63fb2